export function extractDevEnvironmentSlotName(location: string): string | undefined {

	return (/(?<slotname>(qa|sandbox)\d+)/u).exec(location)?.groups!['slotname'];
}
